import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import UserContext from '../../context/UserContext.js';
import FiltrosClubes from './FiltrosClubes.js';
import NuevoClubFiltro from './NuevoClubFiltro.js';
import RecuadroArgentina from './RecuadroArgentina.js';
import PanelAgregarResponsive from '../UI/PanelAgregarResponsive.js';
import CeldaOrdenable from '../UI/CeldaOrdenable.js';
import { TituloPagina } from '../funciones/Funciones.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import * as FuncionesOrdenamiento from '../funciones/FuncionesOrdenamiento.js';
import styles from './BaseClubes.module.css';

const BaseClubes = (props) => {
  const [searchParameters] = useSearchParams();
  const [lista, setLista] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [ordenamientos, setOrdenamientos] = useState([
    { campo: FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE, ascendente: true },
  ]);
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  useEffect(() => {
    document.title = TituloPagina(BaseClubes.name);
  }, []);

  const onBuscando = () => {
    setLista([]);
    setBuscando(true);
  };

  const onListaCargada = (clubes) => {
    setBuscando(false);
    setLista(clubes);
  };

  return (
    <div className={`${styles.baseClubes}`}>
      <FiltrosClubes
        searchParams={searchParameters}
        onBuscando={onBuscando}
        onListaCargada={onListaCargada}
        initialCollapsed={true}
        hasResults={lista && lista.length > 0}
      />
      {lista === null && !buscando && <RecuadroArgentina />}
      <PanelAgregarResponsive
        Componente={NuevoClubFiltro}
        objeto="club"
        lista={lista}
        onListaCargada={onListaCargada}
        puedeEditar={puedeEditar}
        buscando={buscando}
      >
        {!buscando && lista && lista.length === 0 && (
          <div className={`${styles.mensajeSinDatos}`}>No se encontraron clubes</div>
        )}
        {lista && lista.length > 0 && (
          <React.Fragment>
            <table className={`${styles.tablaClubes}`}>
              <thead>
                <tr className={`${styles.filaTitulos}`}>
                  <CeldaOrdenable
                    campo={FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE}
                    label="Nombre"
                    ordenamientos={ordenamientos}
                    onChange={setOrdenamientos}
                    className={styles.headerNombre}
                    title="Click para ordenar. Shift+Click para ordenamiento secundario"
                  />
                  <CeldaOrdenable
                    campo={FuncionesOrdenamiento.CamposOrdenamiento.PAIS}
                    label="País"
                    ordenamientos={ordenamientos}
                    onChange={setOrdenamientos}
                    className={styles.headerPais}
                    title="Click para ordenar. Shift+Click para ordenamiento secundario"
                  />
                  <CeldaOrdenable
                    campo={FuncionesOrdenamiento.CamposOrdenamiento.LOCALIDAD}
                    label="Localidad"
                    ordenamientos={ordenamientos}
                    onChange={setOrdenamientos}
                    className={styles.headerLocalidad}
                    title="Click para ordenar. Shift+Click para ordenamiento secundario"
                  />
                  <CeldaOrdenable
                    campo={FuncionesOrdenamiento.CamposOrdenamiento.FUNDACION}
                    label="Fundación"
                    ordenamientos={ordenamientos}
                    onChange={setOrdenamientos}
                    className={styles.headerFundacion}
                    title="Click para ordenar. Shift+Click para ordenamiento secundario"
                  />
                </tr>
              </thead>
              <tbody>
                {FuncionesOrdenamiento.ordenarListaMultiNivel(
                  lista,
                  ordenamientos,
                  FuncionesOrdenamiento.configClubes
                ).map((club) => {
                  return (
                    <tr key={club.id} className={`${styles.filaClub}`}>
                      <td>
                        <Link to={'/club/' + club.id}>{club.nombre}</Link>
                      </td>
                      <td>{club.pais && club.pais.nombre}</td>
                      <td>{club.localidad && club.localidad.nombre}</td>
                      <td>
                        {FuncionesFecha.CamposToFechaCorta(
                          club.anioFundacion,
                          club.mesFundacion,
                          club.diaFundacion
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </React.Fragment>
        )}
      </PanelAgregarResponsive>
    </div>
  );
};

export default BaseClubes;
